import Preloader from '../svg/common/preloader';

const FormPreloader = () => {
    return (
        <div className="flex justify-center">
            <Preloader width="25px" height="25px" color="#4f4f4f" />
        </div>
    )
};

export default FormPreloader;